import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useReveal, useFloatBtn } from '../components/hooks';
import Footer from '../components/Footer';
import './Packages.css';

const pkgFaqs = [
  { q: 'Which package is right for me?', a: 'If you want a premium custom plan with structured weekly accountability, IGNITE is perfect. If you want Liam in your corner daily — messaging, calling, adjusting your plan in real time — FORGE is the one. Both deliver real results; FORGE delivers them faster with more support.' },
  { q: 'Can I upgrade from IGNITE to FORGE?', a: 'Absolutely. Many clients start with IGNITE and upgrade to FORGE once they\'re ready for the full experience. Just message Liam via the client portal and the upgrade can be processed within 24 hours.' },
  { q: 'What happens after I sign up?', a: 'Once your application is submitted, Liam will review it within 24 hours and reach out to schedule your free 30-minute discovery call. From there, your fully custom plan is built and delivered within 48 hours of the call.' },
  { q: 'Do I need to be local for in-person sessions?', a: 'Yes — in-person sessions are available exclusively for clients local to Liam. FORGE clients receive a discounted rate on each session. If you\'re not local, the full online experience delivers the exact same results.' },
  { q: 'How do payments work?', a: 'Both packages are monthly rolling subscriptions. You\'re billed on the same date each month and can cancel any time with no penalties. Annual billing (available for 20% off) is billed once upfront.' },
  { q: 'What if I have a medical condition or injury?', a: 'Please mention any medical conditions or injuries in your application. Liam will build your programme around your specific situation. He has coached clients recovering from surgeries, managing chronic conditions, and more.' },
];

const igniteTestis = [
  { res: '−10kg', initials: 'TC', name: 'Tom C.', detail: 'IGNITE · Online · Lost 10kg', txt: '"I started IGNITE not knowing what to expect. Within 6 weeks the plan had already changed my body more than years of going to the gym alone. The nutrition plan is worth it alone."' },
  { res: '+6kg muscle', initials: 'SR', name: 'Sophie R.', detail: 'IGNITE · Online · Body recomp', txt: '"As a beginner I needed structure, not a template. IGNITE gave me a real programme I actually understood and could follow. My confidence in the gym has completely changed."' },
  { res: '−8kg', initials: 'MK', name: 'Mark K.', detail: 'IGNITE · Home Training · −8kg', txt: '"The weekly check-ins kept me honest. Having a proper plan finally got me results after years of spinning my wheels. Genuinely worth every penny of the £49.99."' },
];
const forgeTestis = [
  { res: '−18kg', initials: 'JM', name: 'James M.', detail: 'FORGE · Online · Lost 18kg', txt: '"The WhatsApp access completely changed the game. Liam replied within the hour every single time. That accountability plus the plan is why I lost 18kg in 12 weeks."' },
  { res: 'Full recomp', initials: 'AL', name: 'Amanda L.', detail: 'FORGE · Online · Full recomp', txt: '"I\'m 47 and in the best shape of my life. The weekly calls with Liam kept me focused and the mindset coaching was something I didn\'t expect to need — but it changed everything."' },
  { res: '−22lbs', initials: 'DK', name: 'Daniel K.', detail: 'FORGE · In-Person & Online · −22lbs', txt: '"I used Liam in person and online — the combination is unbeatable. The FORGE package at £99.99 a month is honestly the best value investment I\'ve made in my health."' },
];

function FaqItem({ q, a, openIdx, idx, setOpenIdx }) {
  return (
    <div className={`faq-item${openIdx === idx ? ' open' : ''}`}>
      <div className="faq-q" onClick={() => setOpenIdx(openIdx === idx ? null : idx)}>
        {q} <span className="faq-ico">+</span>
      </div>
      <div className="faq-a"><p>{a}</p></div>
    </div>
  );
}

function ApplicationForm() {
  const [selectedPkg, setSelectedPkg] = useState('IGNITE');
  const [submitted, setSubmitted] = useState(false);
  const [form, setForm] = useState({ first:'', last:'', email:'', phone:'', age:'', gender:'', location:'', training:'', goal:'', exp:'', injuries:'', notes:'', consent:false });

  const handleChange = e => {
    const { id, value, type, checked } = e.target;
    setForm(f => ({ ...f, [id.replace('f-','')]: type === 'checkbox' ? checked : value }));
  };

  const handleSubmit = () => {
    if (!form.first || !form.email || !form.goal || !form.consent) {
      alert('Please fill in all required fields and accept the terms to continue.');
      return;
    }
    setSubmitted(true);
    setTimeout(() => window.scrollTo({ top: document.getElementById('signup').offsetTop, behavior: 'smooth' }), 100);
  };

  return (
    <section id="signup">
      <div className="signup-wrap">
        {!submitted ? (
          <>
            <div className="signup-header">
              <div className="s-label rev" style={{ justifyContent: 'center' }}><span>Let's Get Started</span></div>
              <h2 className="s-title rev">APPLY NOW</h2>
              <p className="rev">Fill in the form below and Liam will personally review your application and reach out within 24 hours to schedule your free discovery call.</p>
            </div>
            <div className="pkg-selector rev">
              <div className={`pkg-opt${selectedPkg === 'IGNITE' ? ' selected' : ''}`} onClick={() => setSelectedPkg('IGNITE')}>
                <div className="pkg-opt-radio"></div>
                <div className="pkg-opt-tier">Starter</div>
                <div className="pkg-opt-name">IGNITE</div>
                <div className="pkg-opt-price"><strong>£49.99</strong> / month</div>
              </div>
              <div className={`pkg-opt${selectedPkg === 'FORGE' ? ' selected' : ''}`} onClick={() => setSelectedPkg('FORGE')}>
                <div className="pkg-opt-radio"></div>
                <div className="pkg-opt-tier">Elite · Most Popular</div>
                <div className="pkg-opt-name">FORGE</div>
                <div className="pkg-opt-price"><strong>£99.99</strong> / month</div>
              </div>
            </div>
            <div id="the-form" className="rev">
              <div className="form-grid">
                <div className="field"><label>First Name *</label><input type="text" id="f-first" placeholder="Your first name" value={form.first} onChange={handleChange} /></div>
                <div className="field"><label>Last Name</label><input type="text" id="f-last" placeholder="Your last name" value={form.last} onChange={handleChange} /></div>
                <div className="field"><label>Email Address *</label><input type="email" id="f-email" placeholder="your@email.com" value={form.email} onChange={handleChange} /></div>
                <div className="field"><label>Phone Number</label><input type="tel" id="f-phone" placeholder="+44 7700 000000" value={form.phone} onChange={handleChange} /></div>
                <div className="field"><label>Age</label><input type="number" id="f-age" placeholder="e.g. 28" min="16" max="80" value={form.age} onChange={handleChange} /></div>
                <div className="field">
                  <label>Gender</label>
                  <select id="f-gender" value={form.gender} onChange={handleChange}>
                    <option value="" disabled>Select...</option>
                    <option>Male</option><option>Female</option><option>Prefer not to say</option>
                  </select>
                </div>
                <div className="field"><label>Where are you based?</label><input type="text" id="f-location" placeholder="City / Town" value={form.location} onChange={handleChange} /></div>
                <div className="field">
                  <label>Training Environment</label>
                  <select id="f-training" value={form.training} onChange={handleChange}>
                    <option value="" disabled>Select...</option>
                    <option>Gym member</option><option>Home setup</option><option>Minimal equipment</option><option>No equipment (bodyweight)</option>
                  </select>
                </div>
                <div className="field form-full">
                  <label>Your Main Goal *</label>
                  <select id="f-goal" value={form.goal} onChange={handleChange}>
                    <option value="" disabled>What do you want to achieve?</option>
                    <option>Lose body fat</option><option>Build muscle</option><option>Lose fat & build muscle simultaneously</option><option>Improve fitness & energy</option><option>Athletic performance</option>
                  </select>
                </div>
                <div className="field form-full">
                  <label>Experience Level</label>
                  <select id="f-exp" value={form.exp} onChange={handleChange}>
                    <option value="" disabled>Select your experience</option>
                    <option>Complete beginner (never trained before)</option><option>Beginner (less than 1 year)</option><option>Intermediate (1–3 years)</option><option>Advanced (3+ years)</option>
                  </select>
                </div>
                <div className="field form-full"><label>Any injuries or medical conditions Liam should know about?</label><textarea id="f-injuries" placeholder="e.g. lower back pain, knee injury — or type 'None'" value={form.injuries} onChange={handleChange}></textarea></div>
                <div className="field form-full"><label>Anything else you'd like Liam to know?</label><textarea id="f-notes" placeholder="Tell Liam anything relevant about your situation, lifestyle, or goals..." value={form.notes} onChange={handleChange}></textarea></div>
                <div className="field form-full">
                  <div className="field-row">
                    <input type="checkbox" id="f-consent" checked={form.consent} onChange={handleChange} />
                    <label htmlFor="f-consent">I agree that my information will be used by Liam W Coaching to contact me about my application. I understand I can cancel at any time and am protected by the 14-day money-back guarantee.</label>
                  </div>
                </div>
              </div>
              <button className="form-submit" onClick={handleSubmit}>Submit My Application →</button>
              <p className="form-note">No commitment required at this stage. Liam will review your application and reach out within 24 hours to schedule your <strong style={{ color: 'var(--gold)' }}>free discovery call</strong>.</p>
            </div>
          </>
        ) : (
          <div className="form-success show">
            <div className="success-icon">🔥</div>
            <h3>APPLICATION RECEIVED</h3>
            <p>Liam has received your application and will personally review it within 24 hours.<br /><br />Expect a message from him to schedule your <strong style={{ color: 'var(--gold)' }}>free 30-minute discovery call</strong> — where you'll map out your entire transformation roadmap together.<br /><br />Get ready. This is where it starts.</p>
          </div>
        )}
      </div>
    </section>
  );
}

export default function Packages() {
  useReveal();
  useFloatBtn();
  const [isAnnual, setIsAnnual] = useState(false);
  const [faqOpen, setFaqOpen] = useState(null);

  const ignitePrice = isAnnual ? '£39.99' : '£49.99';
  const forgePrice = isAnnual ? '£79.99' : '£99.99';
  const igniteNote = isAnnual ? 'Billed annually · Cancel anytime' : 'Billed monthly · Cancel anytime';
  const forgeNote = isAnnual ? 'Billed annually · Limited spots' : 'Billed monthly · Limited spots';

  const tableRows = [
    { group: 'Training' },
    { feat: 'Custom training programme', note: 'Built entirely around your body & goals', ignite: 'check', forge: 'check' },
    { feat: 'Gym or home training option', ignite: 'check', forge: 'check' },
    { feat: 'Exercise video library', ignite: 'check', forge: 'check' },
    { feat: 'Programme update frequency', ignite: 'Every 4–6 wks', forge: 'Every 3–4 wks', gold: true },
    { feat: 'In-person sessions', note: 'Available for local clients', ignite: 'cross', forge: 'Discounted', gold: true },
    { group: 'Nutrition' },
    { feat: 'Bespoke nutrition plan', ignite: 'check', forge: 'check' },
    { feat: 'Calorie & macro targets', ignite: 'check', forge: 'check' },
    { feat: 'Supplement guidance', ignite: 'check', forge: 'check' },
    { feat: 'Body composition tracking', note: 'Detailed biometric monitoring', ignite: 'cross', forge: 'check' },
    { feat: 'Ongoing nutrition adjustments', ignite: 'Monthly', forge: 'Weekly', gold: true },
    { group: 'Support & Coaching' },
    { feat: 'Private client portal', ignite: 'check', forge: 'check' },
    { feat: 'Weekly check-in', ignite: 'Portal', forge: 'Video Call', gold: true },
    { feat: 'Direct WhatsApp access to Liam', ignite: 'cross', forge: 'check' },
    { feat: 'Response time guarantee', ignite: '48 hrs', forge: '24 hrs', gold: true },
    { feat: 'Mindset & lifestyle coaching', ignite: 'cross', forge: 'check' },
    { group: 'Guarantees' },
    { feat: '14-day money-back guarantee', ignite: 'check', forge: 'check' },
    { feat: 'Results guarantee', note: 'Free coaching until you see results', ignite: 'cross', forge: 'check' },
    { feat: 'Cancel anytime', ignite: 'check', forge: 'check' },
  ];

  const renderVal = (val, gold) => {
    if (val === 'check') return <span className="check">✓</span>;
    if (val === 'cross') return <span className="cross">✗</span>;
    return <span className={`val-text${gold ? ' val-gold' : ''}`}>{val}</span>;
  };

  return (
    <>
      {/* HERO */}
      <section id="phero">
        <div className="phero-bg"></div>
        <div className="phero-grid"></div>
        <div className="phero-tag"><div className="phero-tag-line"></div><span>Choose Your Path · Start Today</span></div>
        <h1 className="phero-title">COACHING<br /><em>PACKAGES</em></h1>
        <p className="phero-sub">Two packages. One goal. A completely transformed body and the energy to match. Every plan is built entirely around you — your body, your schedule, your life.</p>
        <div className="phero-urgency"><div className="udot"></div><span>I only take on 10 clients at a time — spots are limited</span></div>
      </section>

      {/* BILLING TOGGLE */}
      <div id="toggle-section">
        <div className="s-label rev" style={{ justifyContent: 'center' }}><span>Billing</span></div>
        <div className="billing-toggle">
          <button className={`toggle-btn${!isAnnual ? ' active' : ''}`} onClick={() => setIsAnnual(false)}>Monthly</button>
          <button className={`toggle-btn${isAnnual ? ' active' : ''}`} onClick={() => setIsAnnual(true)}>Annual <span className="save-badge">Save 20%</span></button>
        </div>
      </div>

      {/* DEEP DIVE CARDS */}
      <section id="deepdive">
        <div className="dd-header">
          <div className="s-label rev">The Packages</div>
          <h2 className="s-title rev">EVERYTHING<br />THAT'S INCLUDED</h2>
        </div>
        <div className="dd-grid">
          {/* IGNITE */}
          <div className="dd-card rev">
            <div className="dd-card-top">
              <div className="dd-tier">Starter Package</div>
              <div className="dd-name">IGNITE</div>
              <div className="dd-tagline">"The spark that changes everything."</div>
            </div>
            <div className="dd-price-block">
              <div className="price-main">{ignitePrice}</div>
              <div className="price-right">
                <div className="price-per">/ month</div>
                <div className="price-note">{igniteNote}</div>
                {isAnnual && <div className="price-annual">£479.90/yr · Save £119.98</div>}
              </div>
            </div>
            <div className="dd-body">
              <p className="dd-desc">IGNITE is your launchpad. A fully bespoke training and nutrition programme built around your body, your goals, and your available equipment — with structured weekly accountability to keep you on track.</p>
              {[
                { title: 'Training', items: ['Custom periodised training programme (gym or home)','Exercise video library with full form guides','Programme updated every 4–6 weeks to prevent plateau','Bodyweight, dumbbell, barbell & machine options'] },
                { title: 'Nutrition', items: ['Bespoke nutrition & meal strategy plan','Calorie & macro targets tailored to your body','Supplement guidance & recommendations','Flexible eating approach — no strict meal plans'] },
                { title: 'Support & Accountability', items: ['Private online client portal access','Weekly structured check-in via portal','Monthly progress review & plan adjustment','14-day full money-back guarantee'], off: ['Direct WhatsApp access to Liam','Weekly 1-on-1 video coaching call','In-person session discount'] },
              ].map(g => (
                <div className="feat-group" key={g.title}>
                  <div className="feat-group-title">{g.title}</div>
                  <ul className="feat-list">
                    {g.items.map(item => <li key={item}><div className="fc on">✓</div>{item}</li>)}
                    {g.off?.map(item => <li key={item}><div className="fc off">✗</div><span style={{ color: 'var(--muted)' }}>{item}</span></li>)}
                  </ul>
                </div>
              ))}
            </div>
            <div className="dd-cta-wrap">
              <a href="#signup" className="dd-btn sec">Get Started with IGNITE →</a>
            </div>
          </div>
          {/* FORGE */}
          <div className="dd-card featured rev" style={{ transitionDelay: '.12s' }}>
            <div className="dd-badge">Most Popular</div>
            <div className="dd-card-top">
              <div className="dd-tier">Elite Package</div>
              <div className="dd-name">FORGE</div>
              <div className="dd-tagline">"Total transformation. Zero compromise."</div>
            </div>
            <div className="dd-price-block">
              <div className="price-main gold">{forgePrice}</div>
              <div className="price-right">
                <div className="price-per">/ month</div>
                <div className="price-note">{forgeNote}</div>
                {isAnnual && <div className="price-annual">£959.90/yr · Save £239.98</div>}
              </div>
            </div>
            <div className="dd-body">
              <p className="dd-desc">FORGE is the complete package. Everything in IGNITE, plus daily direct access to Liam on WhatsApp, weekly coaching calls, deep body composition tracking, and mindset coaching — the full experience for those serious about real, lasting change.</p>
              {[
                { title: 'Training', items: ['Custom 12-week periodised training programme','Exercise video library with full form guides','Programme updated every 3–4 weeks','In-person sessions available (local clients — discounted rate)'] },
                { title: 'Nutrition', items: ['Advanced nutrition, macro & meal planning','Full body composition & biometric tracking','Supplement stack & timing guidance','Ongoing nutrition adjustments based on progress'] },
                { title: 'Support & Accountability', items: ['Direct WhatsApp access to Liam (daily support)','Weekly 1-on-1 video coaching call','Priority 24-hour response guarantee','Mindset, habit & lifestyle coaching','Private online client portal access','14-day full money-back guarantee','Results guarantee — free coaching until you do'] },
              ].map(g => (
                <div className="feat-group" key={g.title}>
                  <div className="feat-group-title">{g.title}</div>
                  <ul className="feat-list">
                    {g.items.map(item => <li key={item}><div className="fc on">✓</div>{item}</li>)}
                  </ul>
                </div>
              ))}
            </div>
            <div className="dd-cta-wrap">
              <a href="#signup" className="dd-btn pri">Apply For FORGE →</a>
            </div>
            <div className="pkg-glow"></div>
          </div>
        </div>
      </section>

      {/* COMPARISON TABLE */}
      <section id="compare">
        <div className="compare-header">
          <div className="s-label rev">Side by Side</div>
          <h2 className="s-title rev">FULL FEATURE<br />COMPARISON</h2>
        </div>
        <div className="table-wrap rev">
          <table>
            <thead>
              <tr>
                <th className="feat-col"></th>
                <th className="pkg-col"><div className="th-inner"><div className="th-pkg-name">IGNITE</div><div className="th-price">{ignitePrice} / mo</div></div></th>
                <th className="pkg-col"><div className="th-inner gold"><div className="th-pkg-name">FORGE</div><div className="th-price">{forgePrice} / mo</div></div></th>
              </tr>
            </thead>
            <tbody>
              {tableRows.map((row, i) =>
                row.group ? (
                  <tr className="group-header" key={i}><td colSpan="3">{row.group}</td></tr>
                ) : (
                  <tr key={i}>
                    <td className="feat-name">{row.feat}{row.note && <small>{row.note}</small>}</td>
                    <td className="pkg-val">{renderVal(row.ignite, false)}</td>
                    <td className="pkg-val">{renderVal(row.forge, row.gold)}</td>
                  </tr>
                )
              )}
            </tbody>
            <tfoot>
              <tr>
                <td></td>
                <td className="td-cta"><a href="#signup" className="tfoot-btn sec">Start IGNITE</a></td>
                <td className="td-cta"><a href="#signup" className="tfoot-btn pri">Apply for FORGE</a></td>
              </tr>
            </tfoot>
          </table>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section id="pkg-testi">
        <div className="pt-header">
          <div className="s-label rev">Client Results</div>
          <h2 className="s-title rev">REAL PEOPLE.<br />REAL TRANSFORMATIONS.</h2>
        </div>
        <div className="pt-grid">
          <div className="rev-l">
            <div className="pt-col-label">IGNITE <span>Clients</span></div>
            <div className="pt-cards">
              {igniteTestis.map(t => (
                <div className="pt-card" key={t.name}>
                  <div className="pt-result">{t.res}</div>
                  <div className="pt-stars">★★★★★</div>
                  <p className="pt-txt">{t.txt}</p>
                  <div className="pt-auth"><div className="pt-av">{t.initials}</div><div><div className="pt-name">{t.name}</div><div className="pt-detail">{t.detail}</div></div></div>
                </div>
              ))}
            </div>
          </div>
          <div className="rev-r">
            <div className="pt-col-label">FORGE <span>Clients</span></div>
            <div className="pt-cards">
              {forgeTestis.map(t => (
                <div className="pt-card forge" key={t.name}>
                  <div className="pt-result">{t.res}</div>
                  <div className="pt-stars">★★★★★</div>
                  <p className="pt-txt">{t.txt}</p>
                  <div className="pt-auth"><div className="pt-av">{t.initials}</div><div><div className="pt-name">{t.name}</div><div className="pt-detail">{t.detail}</div></div></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section id="pkg-faq">
        <div className="s-label rev">Package Questions</div>
        <h2 className="s-title rev">BEFORE YOU<br />SIGN UP</h2>
        <div className="faq-grid">
          <div className="faq-left rev-l">
            <p>Everything you need to know about the packages before committing. Still unsure? Apply and Liam will personally answer any questions on your free discovery call.</p>
            <div className="guarantee-box">
              <h4>🔒 The Guarantee</h4>
              <p>Both packages include a <strong style={{ color: 'var(--gold)' }}>full 14-day refund</strong>, no questions asked. On FORGE, if you follow the programme 100% and don't see results, Liam will keep coaching you <strong style={{ color: 'var(--gold)' }}>completely free</strong> until you do. That's how confident he is.</p>
            </div>
          </div>
          <div className="faq-items rev-r">
            {pkgFaqs.map((f, i) => (
              <FaqItem key={i} q={f.q} a={f.a} idx={i} openIdx={faqOpen} setOpenIdx={setFaqOpen} />
            ))}
          </div>
        </div>
      </section>

      {/* SIGN-UP FORM */}
      <ApplicationForm />

      <Footer />
      <a href="#signup" className="float-btn" id="floatBtn">Apply Now →</a>
    </>
  );
}
